import { DashboardT } from 'business/definitions';
import useGetDashboardFilters from 'components/QueryPerimeter/hooks/useGetDashboardFilters';
import { convertToQueryFilters } from 'helpers/filterHelper';
import { compact } from 'lodash';

/**
 * Gets the list of dashboard filters along with navigation one
 */
export const useGetExtraFilters = (
    disableDashboardFilters: boolean,
    dashboard: DashboardT | undefined,
    navigationFilter?: QueryFilterT | undefined,
): { data: QueryFilterT[]; isLoading: boolean } => {
    const { data: dashboardFilters, isLoading } =
        useGetDashboardFilters(dashboard);
    if (disableDashboardFilters) {
        return navigationFilter
            ? { data: [navigationFilter], isLoading: false }
            : { data: [], isLoading: false };
    }

    const perimeterFilters =
        dashboardFilters?.filter(
            (f) =>
                f.value != null &&
                f.value !== '' &&
                f.field !== navigationFilter?.field,
        ) ?? [];
    return {
        data: compact([
            ...convertToQueryFilters(perimeterFilters),
            navigationFilter,
        ]),
        isLoading: isLoading,
    };
};
